// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__8qD9P","selectSelect":"style_selectSelect__kayIG"};